import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

import {
  LOAD_COMPANY_SITE_LIST,
  LOAD_COMPANY_SITE_LIST_SUCCESS,
  LOAD_COMPANY_SITE_LIST_ERROR,
  LOAD_COMPANY_SITE_DETAIL,
  LOAD_COMPANY_SITE_DETAIL_SUCCESS,
  LOAD_COMPANY_SITE_DETAIL_ERROR,
} from '../type';

const companySiteReducer = handleActions(
  new Map([
    [
      LOAD_COMPANY_SITE_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            companySiteListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_COMPANY_SITE_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            companySiteListLoading: { $set: false },
          },
          companySiteList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_COMPANY_SITE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            companySiteListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_COMPANY_SITE_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            companySiteDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_COMPANY_SITE_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            companySiteDetailLoading: { $set: false },
          },
          companySiteDetail: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_COMPANY_SITE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            companySiteDetailLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default companySiteReducer;
